<template>
  <div class="bg-[rgba(93,93,152,0.55)] w-full p-4 rounded-md flex flex-col min-h-[400px]">
    <h1 class="title">Chat Grupo</h1>
    <div class="flex justify-between items-center mb-4 text-black">
      <input v-model="searchQuery" type="text" class="p-2 rounded-md text-black bg-white"
        placeholder="Procura Mensagens..." />
    </div>

    <div class="flex flex-col items-start gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2 w-full">
      <div ref="chatWindow" class="rounded-md bg-[#545484] p-2 overflow-y-auto chat-window w-full">
        <div class="flex flex-col gap-2" v-for="(message, index) in filteredMessages" :key="index">
          <div class="flex items-center justify-between">
            <strong class="text-[#ff9b05]">{{ message.username }}</strong> <!-- Texto laranja vibrante -->
          </div>
          <div class="text-white text-sm">{{ message.message }}</div>
        </div>
      </div>
    </div>

    <form @submit.prevent="submit" class="mt-4 w-full">
      <input type="text" class="rounded-md p-2 w-full text-black bg-white mt-2" placeholder="Escreva sua mensagem aquí"
        v-model="message" />
      <button type="submit" class="button mt-2 px-4 py-1 bg-[#38bdf8] rounded-lg shadow-lg hover:bg-[#0ea5e9] text-white w-full">
        Enviar
      </button>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed, nextTick } from 'vue';
// import Pusher from 'pusher-js';  // Commented out Pusher import
import axios from 'axios';

export default {
  name: 'GeneralChat',
  setup() {
    const username = ref('');
    const messages = ref([]);
    const message = ref('');
    const searchQuery = ref('');
    const chatType = ref('general'); // Default to general chat
    const baseURL = process.env.VUE_APP_URL_BASE;
    const chatWindow = ref(null);

    onMounted(async () => {
      const userLogado = JSON.parse(localStorage.getItem('user'));
      if (userLogado && userLogado.user) {
        username.value = userLogado.user;
      }

      const storedMessages = JSON.parse(localStorage.getItem('chatMessages'));
      if (storedMessages) {
        messages.value = storedMessages;
      }

      // Pusher real-time chat functionality commented out
      /*
      Pusher.logToConsole = false;

      const pusher = new Pusher('1c5160e5c87872d20a6f', {
        cluster: 'eu',
      });

      const generalChannel = pusher.subscribe('general-chat');
      generalChannel.bind('message', data => {
        messages.value.push(data);
        scrollToBottom();
      });
      */
    });

    watch(messages, (newMessages) => {
      localStorage.setItem('chatMessages', JSON.stringify(newMessages));
    }, { deep: true });

    const filteredMessages = computed(() => {
      return messages.value.filter(message =>
        message.message.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const submit = async () => {
      if (!message.value) {
        alert('Por favor, insira uma mensagem.');
        return;
      }

      await fetch(`${baseURL}/api/v1/messages/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: username.value,
          message: message.value,
          chatType: chatType.value
        }),
      });

      message.value = '';
    };

    const scrollToBottom = () => {
      nextTick(() => {
        if (chatWindow.value) {
          chatWindow.value.scrollTop = chatWindow.value.scrollHeight;
        }
      });
    };

    return {
      username,
      messages,
      message,
      searchQuery,
      chatType,
      submit,
      filteredMessages,
      chatWindow
    };
  },
};
</script>

<style scoped>
.chat-window {
  max-height: 300px;
  min-height: 200px;
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #ff9b05 #545484; /* Barras de rolagem personalizadas */
}

input[type="text"] {
  border-radius: 5px;
  padding: 0.5rem;
  border: 1px solid #cccccc;
  font-size: 0.875rem;
  width: 100%;
  background-color: white;
  color: black;
}

button {
  background-color: var(--button-color);
  border-radius: 5px;
  padding: 0.5rem;
  font-size: 0.875rem;
  width: 100%;
}

.title {
  font-size: 1.25rem;
  color: var(--title-color);
}

.flex {
  display: flex;
}


</style>
